module.exports = {
    'pt-BR': require('./ptBR/ptBR.json'),
    'en': require('./en/en.json')
}